import React from "react";
import Navbar from "../features/Navbar/Navbar";
import Profile from "../features/user/component/Profile";

export default function MyOrderPage() {
  return (
    <>
      <Navbar></Navbar>
      <Profile></Profile>
    </>
  );
}
